import React, { useEffect } from 'react';
import { ContactUsFilter } from '../ContactUsFilter';
import { SubOfficeList } from './components';
import './FindOffice.scss';

import { ContactUsData } from '../../ContactUs.types';

interface FindOfficeProps {
  data: ContactUsData;
  onBackClick: () => void;
}

export const FindOffice = ({ data, onBackClick }: FindOfficeProps) => {
  const isBtnClicked = localStorage.getItem('OffBtnClicked');

  useEffect(() => {
    const allMatchedElements = document.getElementsByClassName('contact-font');
    if (allMatchedElements.length)
      allMatchedElements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, []);

  const goBack = () => {
    const url = window.location.href;
    const newURL = url.split('?');
    if (newURL && isBtnClicked == 'true') {
      localStorage.removeItem('OffBtnClicked');
      window.history.pushState({}, null, newURL[0]);
      window.history.go();
    } else {
      onBackClick();
    }
  };

  return (
    <div className='c-contact-find-off l-content l-page-center'>
      <div className='l-section l-section-100 c-contact-findoff'>
        <p className='c-contact-find-update' onClick={goBack}>
          <i className='icon-arrow-left'></i>
        </p>
        <h1 className='contact-font'>{data && data.Page && data.Page.FindYourContactsLinkText}</h1>
        <div className='c-contact-filter'>
          <ContactUsFilter />
        </div>
        <SubOfficeList data={data} />
      </div>
    </div>
  );
};
